var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.d{fill:none;}.a{stroke:rgba(67,138,254,0.3);stroke-width:4px;}.b{fill:#438afe;}.c{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 3.999)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-4 -3.999)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 20,
    cy: 20,
    r: 18
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M16,0A16,16,0,1,0,32,16,16,16,0,0,0,16,0Zm0,4.784a5.292,5.292,0,1,1-5.292,5.292A5.293,5.293,0,0,1,16,4.785Zm0,23.033A11.743,11.743,0,0,1,8.35,25a2.255,2.255,0,0,1-.791-1.714,5.337,5.337,0,0,1,5.363-5.336h6.158a5.33,5.33,0,0,1,5.355,5.336A2.25,2.25,0,0,1,23.645,25,11.739,11.739,0,0,1,16,27.818Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/userProfile.09238cd6b006b94b28fd0ffab3ef9be2.svg";
export { ForwardRef as ReactComponent };